import React, { useEffect, useRef } from "react"
import { connectSearchBox } from "react-instantsearch-dom"

export default connectSearchBox(
  ({ refine, currentRefinement, className, placeholder, onFocus }) => {
    const inputRef = useRef(null)

    useEffect(() => {
      if (inputRef.current !== null) {
        inputRef.current.focus()
      }
    }, [inputRef])

    return (
      <form className={className}>
        <input
          ref={inputRef}
          id="algoliaInput"
          className="SearchInput"
          type="text"
          placeholder={placeholder}
          aria-label="Search"
          onChange={e => refine(e.target.value)}
          value={currentRefinement}
          onFocus={onFocus}
          onKeyDown={event => {
            if (event.keyCode === 13) {
              event.preventDefault()
            }
          }}
        />
      </form>
    )
  }
)
